import React from 'react';
import { EntityId } from "@reduxjs/toolkit";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { destroyChallenge } from "src/actions/mine_craft/challengesActions";
import { selectChallengeEntities, selectChallengeIds, setEditId } from "src/store/mine_craft/challengesSlice";
import usePermissions from "src/hooks/usePermissions";

import { Image, message, Spin } from "antd";
import { AppstoreOutlined, MessageOutlined } from "@ant-design/icons";
import CardImage from "src/componets/CardImage";
import Pagination from 'src/componets/Pagination';
import IconText from "src/componets/IconText";
import { ButtonDestroy, ButtonEdit } from "src/componets/Buttons";
import { formattedDate } from "src/helpers/DateHelpers";
import moment from "moment";

interface propsInterface {
  limit: number;
}

const _List = ({ limit }: propsInterface) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const ids = useAppSelector(selectChallengeIds);
  const items = useAppSelector(selectChallengeEntities);
  const count = useAppSelector(state => state.mineCraft.challenges.count);
  const error = useAppSelector(state => state.mineCraft.challenges.error);
  const status = useAppSelector(state => state.mineCraft.challenges.status);
  const { write_minecraft } = usePermissions();

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId) {
    handleDestroy(id).catch(console.error);
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyChallenge(id));

    if (destroyChallenge.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(0), 1000);
    }

    if (destroyChallenge.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  const renderList = (id: EntityId) => {
    const item = items[id];
    const ribbon: any = {
      color: 'volcano',
      placement: 'start',
      text: 'active'
    };

    if (!item) {
      return;
    }
    const formattedEndAt = formattedDate(item.end_at);
    const startAt = moment(item.start_at);
    const endAt = moment(item.end_at);
    const now = moment();

    switch (true) {
      case startAt < now && endAt > now:
        ribbon.text = 'active';
        ribbon.color = 'volcano';
        break;
      case startAt > now:
        ribbon.text = 'upcoming';
        ribbon.color = 'cyan';
        break;
      case endAt < now && endAt < now:
        ribbon.text = 'ended';
        ribbon.color = '#b3b3b3';
        break;
    }

    return (
      <CardImage
        key={item.id}
        size='medium'
        className='v-challenge-card'
        image={item.thumbnail_url}
        title={item.title}
        link={item.url}
        ribbon={ribbon}
        stats={[
          <Image src={item.ico_url} width={12} height={12} preview={false} />,
          <IconText icon={MessageOutlined} text={item.comments_count} />,
          <IconText icon={AppstoreOutlined} text={item.addons_count} />,
        ]}
        options={write_minecraft ? [
          <ButtonEdit key={`edit-${item.id}`} onClick={() => onClickEdit(item.id)} />,
          <ButtonDestroy key={`destroy-${item.id}`} onClick={() => onClickDestroy(item.id)} />
        ] : []}
      >
        <div className='v-small_text'>
          {formattedEndAt && <small>{formattedEndAt.date} <small>{formattedEndAt.time}</small></small> }
        </div>
      </CardImage>
    )
  }

  if (status === 'loading') {
    return <Spin/>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>
  }

  return (
    <>
      <div className='v-challenges-list'>
        {ids && ids.map(renderList)}
      </div>

      <Pagination total={count} size={limit} />
    </>
  );
}

export default _List;
